import e from "big.js";
//#region src/lib/roundingMode.ts
var t = {
	Down: e.roundDown,
	HalfUp: e.roundHalfUp,
	HalfEven: e.roundHalfEven,
	Up: e.roundUp
}, n = e();
n.NE = -n.DP;
var r = /^-0(\.0+)?$/, i = class e {
	core;
	constructor(e) {
		this.core = e;
	}
	static from(t) {
		return t instanceof e ? t : new e(new n(t));
	}
	static max(t, ...n) {
		return n.reduce((t, n) => {
			let r = e.from(n);
			return r.greaterThan(t) ? r : t;
		}, e.from(t));
	}
	static min(t, ...n) {
		return n.reduce((t, n) => {
			let r = e.from(n);
			return r.lessThan(t) ? r : t;
		}, e.from(t));
	}
	static toCore(t) {
		return e.from(t).core;
	}
	abs() {
		return new e(this.core.abs());
	}
	plus(t) {
		return new e(this.core.plus(e.toCore(t)));
	}
	minus(t) {
		return new e(this.core.minus(e.toCore(t)));
	}
	multiply(t) {
		return new e(this.core.times(e.toCore(t)));
	}
	divide(t) {
		return new e(this.core.div(e.toCore(t)));
	}
	pow(t) {
		return new e(this.core.pow(t));
	}
	equals(t) {
		return this.core.eq(e.toCore(t));
	}
	greaterThan(t) {
		return this.core.gt(e.toCore(t));
	}
	greaterOrEqualThan(t) {
		return this.core.gte(e.toCore(t));
	}
	lessThan(t) {
		return this.core.lt(e.toCore(t));
	}
	lessOrEqualThan(t) {
		return this.core.lte(e.toCore(t));
	}
	isZero() {
		return this.core.eq(0);
	}
	isPositive() {
		return this.core.gt(0);
	}
	isNegative() {
		return this.core.lt(0);
	}
	toFixed(e, n = t.Down) {
		let i = this.core.toFixed(e, n);
		return r.test(i) ? i.slice(1) : i;
	}
	toFixedTrimmed(e, r = t.Down) {
		return new n(this.toFixed(e, r)).toString();
	}
	toNumber() {
		return this.core.toNumber();
	}
	toString() {
		return this.core.toString();
	}
};
//#endregion
export { i as DecimalHelper, t as RoundingMode };
